import { render, staticRenderFns } from "./CompareProducts.vue?vue&type=template&id=87009b60&scoped=true&"
import script from "./CompareProducts.vue?vue&type=script&lang=js&"
export * from "./CompareProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87009b60",
  null
  
)

export default component.exports